import { DownloadStatement } from "@portal/BaseComponents/Activites/DownloadStatement/DownloadStatement";
import { PromiseToPay } from "@portal/BaseComponents/Activites/PromiseToPay/PromiseToPay";
import { RaiseDispute } from "@portal/BaseComponents/Activites/RaiseADispute/RaiseDispute";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { HideWrapper } from "@portal/BaseComponents/HideWrapper/HideWrapper";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { usePrivileges } from "@portal/hooks/use-privilleges";
import useEntityQueryParams from "@portal/hooks/useEnityQueryParams";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { useAtomValue } from "jotai";

function ActionArea() {
  const userConfig = useAtomValue(userConfigAtom);
  const { getPTPPrivilege, getDisputePrivilege, getUserPrivilege } =
    usePrivileges();
  const { isDisputeAction, isPTPAction, defaultValue, isLoading } =
    useEntityQueryParams();

  const ActionButtons = (
    <Flex align="center" justify="start">
      <HideWrapper hide={!getPTPPrivilege("PTP_CREATE")}>
        <PromiseToPay
          buttonProps={{
            theme: "bordered",
            actionButton: true,
          }}
          open={isPTPAction}
          loading={isLoading}
          defaultInvoice={isPTPAction ? defaultValue : undefined}
          key={defaultValue?.length}
        />
      </HideWrapper>
      <HideWrapper hide={!getDisputePrivilege("DISPUTE_CREATE")}>
        <RaiseDispute
          buttonProps={{ theme: "bordered", actionButton: true }}
          open={isDisputeAction}
          defaultInvoices={isDisputeAction ? defaultValue : undefined}
          key={defaultValue?.length}
        />
      </HideWrapper>
      <HideWrapper hide={!getUserPrivilege("DOWNLOAD_SOA")}>
        <DownloadStatement
          buttonProps={{ theme: "bordered", actionButton: true }}
        />
      </HideWrapper>
    </Flex>
  );

  const Title = (
    <Flex align="center" justify="center" space="12">
      <TypographyText style={{ color: "var(--gray-1)" }} fs="24" strong>
        {userConfig.user_details?.customer.name}
      </TypographyText>
    </Flex>
  );
  return (
    <Flex align="center" justify="space-between" style={{ width: "100%" }}>
      {Title}
      {ActionButtons}
    </Flex>
  );
}

export { ActionArea };
